import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import { fetchGetNewbuildingsInfoForTgb } from '@/repositories/generated/shared/newbuilding-search/v1/get-newbuildings-info-for-tgb';

export const fetchGetNewbuildingsInfoForTgbSafe = withTypeSafeApiResult(fetchGetNewbuildingsInfoForTgb);
